export const CONSENT_STORAGE_KEY = "humn_cookie_consent_v1";
export const CONSENT_VERSION = "1.0";

export const readConsent = () => {
  if (typeof window === "undefined") return null;

  try {
    const stored = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_KEY));
    if (stored?.version !== CONSENT_VERSION || typeof stored?.choices?.analytics !== "boolean") {
      return null;
    }
    return stored;
  } catch {
    return null;
  }
};

export const persistConsent = (analytics) => {
  const consent = {
    version: CONSENT_VERSION,
    consentedAt: new Date().toISOString(),
    choices: { essential: true, analytics },
  };

  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch {
    // The in-memory choice still applies when browser storage is unavailable.
  }

  window.dispatchEvent(new CustomEvent("humn:consent-changed", { detail: consent }));
  return consent;
};

export const hasAnalyticsConsent = () => readConsent()?.choices.analytics === true;